import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0c5c8333 = () => interopDefault(import('./prismic/pages/preview.vue' /* webpackChunkName: "" */))
const _186735a5 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _0c9ae2ea = () => interopDefault(import('../../../pages/gdpr.vue' /* webpackChunkName: "pages/gdpr" */))
const _0cce136f = () => interopDefault(import('../../../pages/news-and-guides/index.vue' /* webpackChunkName: "pages/news-and-guides/index" */))
const _facabe3c = () => interopDefault(import('../../../pages/nurole-podcast-enter-the-boardroom.vue' /* webpackChunkName: "pages/nurole-podcast-enter-the-boardroom" */))
const _6f93410d = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0281ac91 = () => interopDefault(import('../../../pages/success-stories/index.vue' /* webpackChunkName: "pages/success-stories/index" */))
const _4409843f = () => interopDefault(import('../../../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _29f0a71a = () => interopDefault(import('../../../pages/website-terms.vue' /* webpackChunkName: "pages/website-terms" */))
const _5e68de68 = () => interopDefault(import('../../../pages/success-stories/by-organisation-type.vue' /* webpackChunkName: "pages/success-stories/by-organisation-type" */))
const _63dfe5aa = () => interopDefault(import('../../../pages/success-stories/by-role.vue' /* webpackChunkName: "pages/success-stories/by-role" */))
const _310e6897 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4a30c1ec = () => interopDefault(import('../../../pages/news-and-guides/category/_slug.vue' /* webpackChunkName: "pages/news-and-guides/category/_slug" */))
const _0b177227 = () => interopDefault(import('../../../pages/news-and-guides/_slug.vue' /* webpackChunkName: "pages/news-and-guides/_slug" */))
const _00cb0b49 = () => interopDefault(import('../../../pages/success-stories/_slug.vue' /* webpackChunkName: "pages/success-stories/_slug" */))
const _2f57c74f = () => interopDefault(import('../../../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/preview",
    component: _0c5c8333,
    name: "prismic-preview"
  }, {
    path: "/contact",
    component: _186735a5,
    name: "contact"
  }, {
    path: "/gdpr",
    component: _0c9ae2ea,
    name: "gdpr"
  }, {
    path: "/news-and-guides",
    component: _0cce136f,
    name: "news-and-guides"
  }, {
    path: "/nurole-podcast-enter-the-boardroom",
    component: _facabe3c,
    name: "nurole-podcast-enter-the-boardroom"
  }, {
    path: "/privacy",
    component: _6f93410d,
    name: "privacy"
  }, {
    path: "/success-stories",
    component: _0281ac91,
    name: "success-stories"
  }, {
    path: "/terms-and-conditions",
    component: _4409843f,
    name: "terms-and-conditions"
  }, {
    path: "/website-terms",
    component: _29f0a71a,
    name: "website-terms"
  }, {
    path: "/success-stories/by-organisation-type",
    component: _5e68de68,
    name: "success-stories-by-organisation-type"
  }, {
    path: "/success-stories/by-role",
    component: _63dfe5aa,
    name: "success-stories-by-role"
  }, {
    path: "/",
    component: _310e6897,
    name: "index"
  }, {
    path: "/news-and-guides/category/:slug?",
    component: _4a30c1ec,
    name: "news-and-guides-category-slug"
  }, {
    path: "/news-and-guides/:slug?",
    component: _0b177227,
    name: "news-and-guides-slug"
  }, {
    path: "/success-stories/:slug?",
    component: _00cb0b49,
    name: "success-stories-slug"
  }, {
    path: "/:slug",
    component: _2f57c74f,
    name: "slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
